import React, { useState } from "react";
import { BILLING_API_URL, SITE, authFetch } from "../../utils/auth";

export default function StripeCard({ partner }) {
  const connected = partner?.stripe_connected;
  const statusLabel = partner?.stripe_status_label || (connected ? "Connected" : "Not Connected");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  async function startStripeConnect() {
    setLoading(true);
    setStatus("");
    try {
      const response = await authFetch(`${BILLING_API_URL}/connect/stripe/start/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Site": SITE,
        },
        body: JSON.stringify({ site: SITE }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Unable to start Stripe onboarding.");
      if (!data.url) throw new Error("Stripe did not return an onboarding link.");
      window.location.href = data.url;
    } catch (err) {
      console.error(err);
      setStatus(err.message || "Unable to start Stripe onboarding.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={`settings-card ${connected ? "good" : "bad"}`}>
      <h3>Stripe & Payouts</h3>

      <div className="row">
        <span>Status</span>
        <strong>{statusLabel}</strong>
      </div>

      {!connected && (
        <>
          <p className="hint">Connect Stripe so approved commissions can be paid to your account.</p>
          <button type="button" className="settings-action" onClick={startStripeConnect} disabled={loading}>
            {loading ? "Opening Stripe..." : "Connect Stripe to Get Paid"}
          </button>
          {status && <small>{status}</small>}
        </>
      )}
    </div>
  );
}